export default __webpack_public_path__ + "static/media/sd.4d107742.png";